import { axiosInstance } from '@/utils/lib/axios';
import { env } from '@/utils/constants/env';

export interface ModuleCompletionStatus {
  is_complete: boolean;
  count: number;
}

export interface CompletionStatusResponse {
  is_fully_complete: boolean;
  company_profile: ModuleCompletionStatus;
  key_activities: ModuleCompletionStatus;
  job_descriptions: ModuleCompletionStatus;
  rewards: ModuleCompletionStatus;
  punishments: ModuleCompletionStatus;
  sops: ModuleCompletionStatus;
  train_trainers: ModuleCompletionStatus;
}

export const getCompletionStatus = async (tenantId: number): Promise<CompletionStatusResponse> => {
  const response = await axiosInstance.get<{
    success: boolean;
    message: string;
    data: CompletionStatusResponse;
  }>(`${env.apiTasklistBaseUrl}/api/v1/compro/company-profile/${tenantId}/completion-status`);

  return response.data.data;
};
